import request from '@/utils/request'

export function epmsa350CutGrp() {
  return request({
    url: `/outsoucingBlockControl/epmsa350/epmsa350CutGrp`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' }
  })
}

export function epmsa350LotNo(param) {
  return request({
    url: `/outsoucingBlockControl/epmsa350/epmsa350LotNo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}

export function epmsa350Detail(param) {
  return request({
    url: `/outsoucingBlockControl/epmsa350/epmsa350Detail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}

export function epmsa350Sum(param) {
  return request({
    url: `/outsoucingBlockControl/epmsa350/epmsa350Sum`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}